import React from "react";
import { getField, deserializeField } from "../../../../util/DynamicItemUtils";

export default function ResponsibilityDivided({ item }: any) {
  const auditDividedInfo = deserializeField(item, "auditdividedinfo");

  function formatAuditString({
    DollarAmount,
    Percentage,
    Criterion,
    OtherCriterion,
  }) {
    const auditString = [
      Criterion === "Other" ? OtherCriterion : Criterion,
      DollarAmount ? `$${Number(DollarAmount).toLocaleString()}` : "",
      DollarAmount && Percentage ? "and" : "",
      Percentage ? `${Percentage}%` : "",
    ].join(" ");
    return auditString;
  }

  function generateFirmCardAuditDividedInfo(firmsInfo) {
    return firmsInfo.map((firm) => {
      const formattedLocation = [firm.City, firm.State, firm.Country]
        .filter((x) => !!x && x !== "United States")
        .join(", ");
      return (
        <div className="firm-details">
          <strong>
            <p>{firm.AuditorName}</p>
          </strong>
          <p>{`FirmID: ${firm.FirmID.length > 0 ? firm.FirmID : "N/A"}`}</p>
          {formattedLocation && (
            <p>{`Office Location: ${formattedLocation}`}</p>
          )}
          <p>{`Audited: ${formatAuditString(firm)}`}</p>
        </div>
      );
    });
  }

  return (
    <div className="form-card">
      <h2>Participation of Other Accounting Firms - Divided Responsibility</h2>
      <h3>
        Identity of the other Public Accounting Firm(s) to which the firm makes
        reference
      </h3>
      {auditDividedInfo ? (
        <div className="firm-details__container">
          {generateFirmCardAuditDividedInfo(auditDividedInfo[0])}
        </div>
      ) : (
        <em>
          <p>None Reported</p>
        </em>
      )}
    </div>
  );
}
